import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import qs from 'qs';
import Fa from 'react-fontawesome';
import { Link, withRouter } from 'react-router-dom';
import { find, first } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';
import requiredSetupMappings from '../../../../components/required-setup-mappings';
import requiredSync from '../../../../components/required-sync';
import orgAwearness from '../../../../components/organization-awearness';
import AnimatedText from '../../../../components/animated-text';
import { fetchOpportunity, fetchAccount } from '../../ApexActions';
import {
  getUser, getUserCurrentOrganization, getIsAdmin, getIsSuperAdmin, getIsUsingOrganizationSwitch,
} from '../../../Auth/AuthReducer';
import getMenus from '../../../App/components/Header/menu';
import { getWinLossOpportunities, getWinLossAccounts } from '../../../Dashboard/DashboardReducer';
import {
  winLossExcludeOpportunity, winLossIncludeOpportunity,
  winLossExcludeAccount, winLossIncludeAccount,
  loadSettings,
} from '../../../Dashboard/DashboardActions';
import ExcludeOpportunityForm from '../../../Feedback/components/opportunity-box/ExcludeOpportunityForm';

class OpportunityExcludePage extends Component {
  constructor(props) {
    super(props);
    const isAccount = props.match?.params?.source === 'accounts';
    this.state = {
      loading: false,
      loaded: false,
      errors: null,
      isAccount,
    };
    this.handleExcludeOpportunity = this.handleExcludeOpportunity.bind(this);
    this.handleIncludeOpportunity = this.handleIncludeOpportunity.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }


  componentDidMount() {
    const { resourceId } = this.props.match.params;
    const query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    const { automationId } = query;
    if (resourceId) {
      this.props.dispatch(loadSettings(automationId, this.props.isAccount));
      this.loadResource(resourceId);
    }
  }


  componentWillReceiveProps(nextProps) {
    const currentId = this.props.match.params.resourceId;
    const nextId = nextProps.match.params.resourceId;
    if (currentId !== nextId) {
      this.loadResource(nextId);
    }
  }

  loadResource(resourceId) {
    if (!this.state.loaded) {
      this.setState({
        loading: true, loaded: false, errors: null,
      });
      const task = this.props.isAccount ? fetchAccount : fetchOpportunity;
      this.props.dispatch(task(resourceId))
        .then(
          () => {
            this.setState({ loading: false, loaded: true, errors: null });
          },
          (errors) => {
            this.setState({ loading: false, loaded: false, errors: errors.data || errors });
          },
        );
    }
  }

  handleExcludeOpportunity(resource, params) {
    const task = this.props.isAccount ? winLossExcludeAccount : winLossExcludeOpportunity;
    const id = this.props.isAccount ? resource.account_id : resource.opportunity_id;
    return this.props.dispatch(task(id, params));
  }

  handleIncludeOpportunity(resource) {
    const task = this.props.isAccount ? winLossIncludeAccount : winLossIncludeOpportunity;
    const id = this.props.isAccount ? resource.account_id : resource.opportunity_id;
    return this.props.dispatch(task(id));
  }

  handleClose() {
    const { feedbackMenu } = this.props;
    const url = feedbackMenu ? feedbackMenu.url : '/';
    this.context.router.history.push(url);
  }

  renderErrors() {
    const { errors } = this.state;
    const message = errors.message || 'Something wrong. Please try again later.';
    return (
      <div style={{ marginTop: 30 }} className="alert alert-danger">
        <p>{message}</p>
      </div>
    );
  }

  renderTitle() {
    const { opportunity, account, feedbackMenu, isAccount } = this.props;
    const name = isAccount ? account.name : opportunity.name;

    let title = (<span>Exclude Feedback Request For {name}</span>);
    if (feedbackMenu) {
      title = (
        <span>
          <Link to={feedbackMenu.url}>{feedbackMenu.label}</Link>
          {' '}
          <Fa name="chevron-right" className="text-muted" />
          {' '}
          {title}
        </span>
      );
    }
    return <h4>{title}</h4>;
  }

  renderContent() {
    const { isAccount } = this.props;
    return (
      <div>
        {this.renderTitle()}
        <div className="panel panel-default">
          <div className="panel-body">
            <ExcludeOpportunityForm
              auth={this.props.user}
              opportunity={isAccount ? this.props.account : this.props.opportunity}
              isModal={false}
              requestExclude={this.handleExcludeOpportunity}
              requestInclude={this.handleIncludeOpportunity}
              onCancel={this.handleClose}
              isAccount={isAccount}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      loading, loaded,
      errors,
    } = this.state;
    const { isAccount } = this.props;

    return (
      <div>
        <Helmet title={isAccount ? 'Exclude Account' : 'Exclude Opportunity'} />
        <div className="container">
          <div style={{ paddingTop: 70 }}>
            {loading &&
              <div>
                <AnimatedText text={isAccount ? 'Syncing account' : 'Syncing opportunity'} />
                <p>One moment please, syncing latest {isAccount ? 'account' : 'opportunity'} information...</p>
                <ProgressBar />
              </div>
            }
            {!loading && errors !== null && this.renderErrors()}
            {!loading && loaded && this.renderContent()}
          </div>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const { match } = ownProps;
  const user = getUser(state);
  const organization = getUserCurrentOrganization(state);
  const canSeeAllPages = getIsAdmin(state) || getIsSuperAdmin(state) || getIsUsingOrganizationSwitch(state);

  const menus = getMenus(user, organization, canSeeAllPages);
  const feedbackMenu = find(menus, { componentKey: 'feedback' });

  return {
    user,
    feedbackMenu,
    opportunity: first(getWinLossOpportunities(state)),
    account: first(getWinLossAccounts(state)),
    isAccount: match?.params?.source === 'accounts',
  };
}

OpportunityExcludePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      resourceId: PropTypes.string,
      source: PropTypes.string,
    }),
  }).isRequired,
  feedbackMenu: PropTypes.shape({
    url: PropTypes.string,
  }),
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
    name: PropTypes.string,
  }),
  account: PropTypes.shape({
    account_id: PropTypes.string,
    name: PropTypes.string,
  }),
  isAccount: PropTypes.bool,
};
OpportunityExcludePage.defaultProps = {
  feedbackMenu: null,
  opportunity: {},
  account: {},
  isAccount: false,
};

OpportunityExcludePage.contextTypes = {
  router: PropTypes.shape({}).isRequired,
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(withRouter(OpportunityExcludePage), ['stage']))));
